class mOrderReturnPanel extends HTMLDivElement {
    constructor() {
        super();

        this.productCheckboxes = this.querySelectorAll('[data-component-select-product]');
        this.quantitySelectors = this.querySelectorAll('[data-component-update-quantity]');
        this.reasonSelectors = this.querySelectorAll('[data-component-update-reason]');
        this.submitButton = this.querySelector('[data-component-submit-button]');
        this.formContainer = this.querySelector('[data-component-form-content]');
        this.successContainer = this.querySelector('[data-component-success-message]');
        this.successGiftCardContainer = this.querySelector('[data-component-success-gift-card-message]');
        this.errorContainer = this.querySelector('[data-component-error-message]');

        const priceFormatInformations = this.querySelector('[data-component-price-format]') || '';
        this.priceFormat = {
            groupingSeparator: priceFormatInformations ? priceFormatInformations.dataset.groupingSeparator : '',
            decimalSeparator: priceFormatInformations ? priceFormatInformations.dataset.decimalSeparator : '',
            decimalCount: priceFormatInformations ? parseInt(priceFormatInformations.dataset.decimalCount, 10) : 0,
        };

        this.updateProductSelection = this.updateProductSelection.bind(this);
        this.updateProductQuantity = this.updateProductQuantity.bind(this);
        this.updateProductReason = this.updateProductReason.bind(this);
        this.submitReturn = this.submitReturn.bind(this);

        this.totalPrice = 0;
        this.priceRegex = /\d.*\d|\d/;

        this.productsSelected = {};
    }

    connectedCallback() {
        this.productCheckboxes.forEach((elem) => {
            elem.addEventListener('change', this.updateProductSelection);
        });
        this.quantitySelectors.forEach((elem) => {
            elem.addEventListener('change', this.updateProductQuantity);
        });
        this.reasonSelectors.forEach((elem) => {
            elem.addEventListener('change', this.updateProductReason);
        });
        this.submitButton.addEventListener('click', this.submitReturn);
        this.updateTotalPrice();
    }

    updateProductSelection(e) {
        const checkbox = e.currentTarget;

        if (checkbox.checked) {
            this.errorContainer.innerText = '';
            const pid = checkbox.getAttribute('data-pid');
            const quantity = this.querySelector(`[data-component-update-quantity][data-pid="${pid}"]`);
            const reason = this.querySelector(`[data-component-update-reason][data-pid="${pid}"]`);
            this.productsSelected[pid] = {
                quantity: quantity ? parseInt(quantity.value, 10) : 1,
                reason: reason.value,
            };
        } else {
            const pid = checkbox.getAttribute('data-pid');
            delete this.productsSelected[pid];
        }
        this.updateTotalPrice();
    }

    formatPrice(price) {
        const [fixedPart, floatPart] = price.toFixed(this.priceFormat.decimalCount).split('.');
        let result = '';
        let count = 0;

        for (let i = fixedPart.length - 1; i >= 0; i--) {
            result = fixedPart[i] + result;
            count++;

            if (count % 3 === 0 && i !== 0) {
                result = this.priceFormat.groupingSeparator + result;
            }
        }

        if (floatPart) {
            result += this.priceFormat.decimalSeparator + floatPart;
        }
        return result;
    }

    updateTotalPrice() {
        let totalPrice = 0;
        const totalPriceNode = this.querySelector('[data-return-total-price]');
        for (const pid of Object.keys(this.productsSelected)) {
            const price = this.querySelector(`[data-product-total-price][data-pid="${pid}"]`);
            totalPrice += parseFloat(price.dataset.totalPrice, 10);
        }
        this.totalPrice = totalPrice;
        const totalPriceFormatted = this.formatPrice(totalPrice);
        totalPriceNode.innerText = totalPriceNode.innerText.replace(this.priceRegex, totalPriceFormatted);
    }

    updatePrice(el, qty) {
        const pli = el.closest('.product-line-item');
        const price = pli.querySelector('.pricing');
        const spanPrice = price.querySelector('span');
        const unitPrice = parseFloat(price.dataset.unitPrice, 10);
        const totalPrice = qty * unitPrice;
        price.dataset.totalPrice = totalPrice;
        const totalPriceFormatted = this.formatPrice(totalPrice);
        spanPrice.innerText = price.innerText.replace(this.priceRegex, totalPriceFormatted);
        this.updateTotalPrice();
    }

    updateProductQuantity(e) {
        const quantitySelector = e.currentTarget;

        if (quantitySelector) {
            const pid = quantitySelector.getAttribute('data-pid');
            const qty = parseInt(quantitySelector.value, 10);
            if (this.productsSelected[pid]) {
                this.productsSelected[pid].quantity = qty;
            }
            this.updatePrice(quantitySelector, qty);
        }
    }

    updateProductReason(e) {
        const reasonSelector = e.currentTarget;

        if (reasonSelector) {
            const pid = reasonSelector.getAttribute('data-pid');
            if (this.productsSelected[pid]) {
                this.productsSelected[pid].reason = reasonSelector.value;
            }
        }
    }

    submitReturn() {
        this.submitButton.disabled = true;
        this.errorContainer.innerText = '';
        if (!Object.keys(this.productsSelected).length) {
            this.submitButton.disabled = false;
            this.errorContainer.innerText = this.dataset.noReturnMessage;
            return;
        }

        const url = this.dataset.submitUrl;
        const data = {
            products: this.productsSelected,
            orderId: this.dataset.orderId,
            orderSid: this.dataset.orderSid,
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }).then((response) => response.json()).then((responseData) => {
            if (responseData.success) {
                this.formContainer.classList.add('d-none');
                if (responseData.giftCard) {
                    this.successGiftCardContainer.classList.remove('d-none');
                } else {
                    this.successContainer.classList.remove('d-none');
                }
                const link = this.querySelector('[data-component-display-voucher-button]');
                if (link && responseData.documentUrl) {
                    link.href = responseData.documentUrl;
                }
                const returnCta = document.querySelector('[data-return-cta]');
                if (returnCta && responseData.hideReturnButton) {
                    returnCta.remove();
                }

                if (responseData.gtmPageData) {
                    document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                        detail: {
                            data: JSON.parse(responseData.gtmPageData),
                        },
                    }));
                }
            } else {
                // TODO: Replace alert with a message into the panel
                this.errorContainer.innerText = responseData.errorMessage;
                this.submitButton.disabled = false;
            }
        }).catch(() => {
            this.submitButton.disabled = false;
        });
    }
}

customElements.define('m-order-return-panel', mOrderReturnPanel, {
    extends: 'div',
});
